import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "42",
  height: "43",
  viewBox: "0 0 42 43",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M0.75 3.99999C0.75 2.20507 2.20507 0.75 4 0.75H38C39.7949 0.75 41.25 2.20507 41.25 4V38.4997C41.25 40.2946 39.7949 41.7497 38 41.7497H4C2.20507 41.7497 0.75 40.2946 0.75 38.4997V3.99999Z",
      fill: "white"
    }, null, -1),
    _createElementVNode("path", {
      d: "M0.75 3.99999C0.75 2.20507 2.20507 0.75 4 0.75H38C39.7949 0.75 41.25 2.20507 41.25 4V38.4997C41.25 40.2946 39.7949 41.7497 38 41.7497H4C2.20507 41.7497 0.75 40.2946 0.75 38.4997V3.99999Z",
      stroke: "#1C1D1F",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "19.9119",
      cy: "20.1617",
      r: "7.1617",
      stroke: "black",
      "stroke-width": "2"
    }, null, -1),
    _createElementVNode("line", {
      x1: "26.0238",
      y1: "24.8593",
      x2: "30.9571",
      y2: "29.7926",
      stroke: "black",
      "stroke-width": "2"
    }, null, -1)
  ])))
}
export default { render: render }